module.exports = __webpack_public_path__ + "img/1.a877d469.png";